"use client";
import { jsx as n } from "react/jsx-runtime";
import g from "clsx";
import { memo as c } from "react";
import { Box as r } from "../../blocks/base/Base.js";
import '../../assets/Tags.css';const u = "_tags_set_1b6gh_2", p = "_tag_1b6gh_2", h = "_active_1b6gh_24", d = "_button_1b6gh_27", v = "_violet_1b6gh_30", w = "_blue_1b6gh_42", y = "_pink_1b6gh_54", N = "_yellow_1b6gh_66", T = "_orange_1b6gh_78", t = {
  tags_set: u,
  tag: p,
  active: h,
  button: d,
  violet: v,
  blue: w,
  pink: y,
  yellow: N,
  orange: T
}, f = c(({ center: e, children: s }) => /* @__PURE__ */ n(r, { gap: 8, row: !0, center: e, className: t.tags_set, children: s }));
f.displayName = "TagsSet";
const x = c(
  ({ text: e, active: s, loading: i, disabled: b, onClick: a, ...l }) => {
    const o = e.toLowerCase(), _ = {
      [t.violet]: o === "all",
      [t.blue]: o === "updates",
      [t.pink]: o === "sale",
      [t.yellow]: o === "event",
      [t.orange]: o === "product"
    }, m = g(t.tag, _, {
      [t.button]: a,
      [t.active]: s,
      [t.loading]: i,
      [t.disabled]: b
    });
    return a ? /* @__PURE__ */ n("button", { className: m, onClick: a, ...l, children: e }) : /* @__PURE__ */ n(r, { gap: 0, center: !0, className: g(t.tag, _), ...l, children: e });
  }
);
x.displayName = "Tag";
export {
  x as Tag,
  f as TagsSet
};
